<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Consulta De Póliza Por Asegurado
        </v-card-title>
        <v-container fluid grid-list-sm>
            <v-form ref="form">
                <v-row dense>
                    <v-col cols="12">
                        <ModalConsultaPolizaClienteComponent :open="obModal.abrirModal"
                                                             :obForm="obModal"
                        />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-autocomplete label="Póliza " color="textbox" v-model="obSearch.idPoliza"
                                :items="listGeneral.listPoliza" item-text="poliza" item-value="id_poliza" outlined dense />    
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field label="N° Certificado " color="textbox" v-model="obSearch.idCertificado" dense
                                outlined :rules="numeroRegla" />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field label="Cédula " color="textbox" v-model="obSearch.nroDocumento" dense
                                outlined :rules="numeroRegla" />
                    </v-col>
                </v-row>

                <v-row dense>
                    <v-col cols="12" sm="8">
                        <v-text-field label="Nombres " color="textbox" v-model="obSearch.cliente" dense
                                outlined :rules="letrasRegla" />
                    </v-col>
                    <v-col cols="12" sm="4" class="text-right">
                        <v-tooltip right color="primary">
                            <template v-slot:activator="{ on }">
                                <v-btn outlined color="primary" @click="onListarDatos" v-on="on" :disabled="disabled">
                                    Buscar<v-icon>search</v-icon>
                                </v-btn>
                            </template>
                            <span>Buscar</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>

            <v-row dense>
                <v-col cols="12" sm="6"/>
                <v-col cols="12" sm="6">
                    <v-text-field label="Buscar" color="textbox" v-model="obSearch.search" clearable dense
                        prepend-inner-icon="search" />
                </v-col>
            </v-row>

            <v-row dense>
                <v-col cols="12" sm="12">
                    <v-data-table :search="obSearch.search" :headers="listGeneral.listCabecera"
                        :items="listDetalle" class="elevation-3">

                        <template v-slot:item.name="{ item }">
                            <v-btn class="ma-2" text icon color="primary" @click="ver(item)">
                                <v-icon small>visibility</v-icon>
                            </v-btn>
                        </template>

                        <template v-slot:no-results>
                            Tu búsqueda de "<span v-html="obSearch.search"></span>" no arrojó resultados.
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: 'ConsultaPolizaClienteView',
        components:{
            ModalConsultaPolizaClienteComponent: () => import('@/components/consulta/polizaClienteMasivo/ModalConsultaPolizaClienteComponent.vue')
        },
        data: () => ({
            obSearch:{
                idPoliza:null,
                idCertificado:null,
                nroDocumento:null,
                cliente:null,
                search:null
            },
            obModal:{
                abrirModal:false,
                titulo:'Información de Póliza'
            },
            listGeneral:{},
            parametros:{},
            disabled:false
        }),
        created(){
            var error = 'E';
            axios.post(`${BASE_URI}administrador/consulta-datos-poliza/cargaGeneralMasivo`)
                 .then((r)=>{
                    if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                    if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                        this.$set(this,'listGeneral',r.data.data.listas);
                        this.$set(this,'parametros',r.data.data.parametros);
                        this.obSearch.idPoliza = this.listGeneral.listPoliza[0].id_poliza;
                 })
                 .catch((e)=>{
                    mensajesAlerta(e,error);
                 });
        },
        computed:{
            listDetalle(){
                var l = [];
                l = _.cloneDeep(this.listGeneral.listDetalle);
                return _.map(l,(v)=>{ return _.get(v,'data',{}); });
            }
        },
        methods:{
            onListarDatos(event){
                if(!_.isUndefined(event)){
                    var error = 'I';
                    var ob = _.cloneDeep(this.obSearch);
                    
                    _.forEach(ob,(v,k)=>{
                        v = _.size(_.toString(v)) == 0 ? null : v;
                        _.set(ob,k,v) 
                    });
                 
                    this.obSearch = ob;
                    this.$refs.form.resetValidation();
                    var o = _.merge(
                                    { opcion:'LISTAR'},
                                    _.omit(this.obSearch,['search'])
                                   );

                    this.listGeneral.listDetalle = [];

                    axios.post(`${BASE_URI}administrador/consulta-datos-poliza/listarMasivo`,o)
                         .then((r)=>{
                            if(_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            if(_.size(_.get(r,['data','data'],[])) == 0) { error='I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                                this.listGeneral.listDetalle = _.map(r.data.data,(v)=>{
                                                                    v.data.index = _.uniqueId();
                                                                    return v;
                                                                });
                        })
                        .catch((e)=>{
                            mensajesAlerta(e,error);
                        });
                }
            },
            ver(v){
                var ob = _.find(this.listGeneral.listDetalle,(o)=>{
                    return o.data.index = v.index
                });
                
                this.$set(this,'obModal',_.merge({},ob,{abrirModal:true, titulo: 'Información Póliza'}));
            },
            closeModal(){
                this.obModal = {
                    abrirModal:false,
                    titulo:'Información de Póliza'
                }
            }
        },
        provide(){
            return{
                closeModal:this.closeModal
            }
        }
    }
</script>